import React from 'react'
import "./Aboutus.css"
import About from "../images/about.jpg"


function Aboutus() {
    return (
        <>
  
            <h1 className="container text-center mb-5 mt-5 text-white">ABOUT US</h1>
            <div class="aboutus-area mt-5">
                <div class="container">
                    <div class="row">
                        {/* <div class="col-xs-12"> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="aboutus-image float-left hidden-sm"><img src={About} alt="" /></div>

                        </div>
                        <div class="col-lg-6col-md-6 col-sm-6 col-xs-12">
                            <div class="aboutus-content ">
                                <h2><p><span>WELCOME TO AESTHETE WORLD</span></p>
                                   <span className="w-content"> We Are The  </span> <span>Photographers</span></h2>

                                <p className="w-content" >Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>
                                <p className="w-content" >A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>

                                <div class="counter ">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="single-counter text-center">
                                            <h2 class="counter"><span>15</span></h2>
                                            <p className="w-content">YEARS OF EXPERIENCED</p>
                                        </div>

                                        <div class="single-counter text-center">
                                            <h2 class="counter"><span>100</span></h2>
                                            <p className="w-content">WEBSITES COMPLETED</p>
                                        </div>

                                        <div class="single-counter text-center">
                                            <h2 class="counter"><span>5</span></h2>
                                            <p className="w-content">AWARDS WON</p>
                                        </div>

                                        <div class="single-counter text-center">
                                            <h2 class="counter"><span>10</span></h2>
                                            <p className="w-content">CLIENTS</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>

        </>
    )
}

export default Aboutus
